import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IpServiceService {
  constructor() {}

  getIPAddress(): Observable<any> {
    return Observable.create((observer) => {
      fetch('https://ipv4.jsonip.com')
        .then((response) => response.json()) // or text() or blob() etc.
        .then((data) => {
          observer.next(data);
          observer.complete();
        })
        .catch((err) => observer.error(err));
    });
  }
}
